<template>
  <div class="RoleAdd">
    <GlobalInfoBar title="角色权限" content="管理总平台账号访问的角色权限添加/编辑" />
    <div class="formRole">
      <div class="case-title">
        <div class="icon_title">
          <div>
            <img class="case-title_icon" src="@/assets/images/imgAll/icon_jsqx_@2x.png" alt />
          </div>
          <div class="case-title_max">{{this.titleDetail}}</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="formdata" v-loading="loading">
        <div class="formitem">
          <div><span style="color:red;margin:5px">*</span>角色名称：</div>
          <div>
            <el-input v-model="roleName" :disabled="pageType=='edit'" placeholder="请输入名称，可按职位命名（限制输入6字符内）" maxlength="6"></el-input>
          </div>
        </div>
        <div class="formitem">
          <div><span style="color:white;margin:5px">*</span>角色说明：</div>
          <div>
            <el-input  :disabled="pageType=='edit'" v-model="roleInfo" placeholder="非必填项（限制输入50字符内）" maxlength="50"></el-input>
          </div>
        </div>
        <div class="formitemTree">
          <div class="title_Tree"><span style="color:red;margin:5px">*</span>菜单权限：</div>
          <div class="treeForm">
            <div class="checkForm">
              <el-tree
                ref="tree"
                default-expand-all
                :data="TreeData"
                :props="props"
                :node-key="props.value"
                @check-change="getCheckedNodes"
                :default-checked-keys="treeListIds"
                show-checkbox
              >
              </el-tree>
            </div>
          </div>
        </div>
        <div class="subBtn">
          <el-button @click="handerClose()">取消</el-button>
          <el-button @click="handerClick()" type="primary">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _api from "@/utils/request";
export default {
  data() {
    return {
      pageType: "",
      titleDetail:"",
      treeListIds:[],
      TreeData:[],
      props: {
          value: 'id',
          children: 'children',
          label: 'menuName'
        },
      roleInfo: "",
      roleName: "",
      treeIds:[],
      roleId:this.$route.query.roleId,
      loading: false
    };
  },
  created() {
    // this.roleInfoRes()
  },
  computed:{
    // RoleinfoData(){
    //   return this.$store.state.tagsView.RoleinfoData
    // }
  },
  mounted(){
    this.pageType = this.$route.query.type
    if(this.$route.query.type ==='edit'){
      this.titleDetail = '编辑角色'
      this.loading = true
      _api.RoleInfoRes({roleId:this.roleId}).then(res => {
        if(res.code === 1 ){
          this.roleInfo = res.data.roleInfo
          this.roleName = res.data.roleName
          this.roleId = res.data.roleId
          this.TreeData = res.data.menus
          // this.$store.commit('tagsView/MENU_LIST',res.data.menus)
          this.getSubMenu(res.data.menus)
          console.log(this.treeListIds);
          console.log(this.treeIds);
          this.$store.commit("tagsView/POST_ROLEINFORES", res.data);
        }
        this.loading = false
      })
    }else{
      this.allRes()
      this.titleDetail = '新增角色'
    }
  },
  methods: {
    //tree数据列表
    allRes(){
      _api.getMenuList().then(res =>{
          this.TreeData = res.data
          this.$store.commit('tagsView/MENU_LIST',res.data)
      })
    },
    // tree点击
    getCheckedNodes () {
        let res = this.$refs.tree.getCheckedKeys()
        let result = this.$refs.tree.getHalfCheckedKeys()
        this.treeIds = res.concat(result)
        console.log(this.treeIds)
    },
    // 提交
    handerClick(){
       
       const params = {
        menuIds: this.treeIds,
        roleInfo: this.roleInfo,
        roleName: this.roleName,
        roleId:this.roleId
      }
      if(this.roleName===''){
        this.$message.error('请输入角色')
      }else if(!this.treeIds.length){
        this.$message.error('请选择权限')
      }else{
        this.loading = true
        if(this.pageType == 'edit') {
          _api.RoleEdit(params).then(res => {
            if(res.code === 1){
              this.$message.success("操作成功")
              this.$router.push({ path: "/systemManage/RolePurview"})
              let roleId = JSON.parse(localStorage.getItem('user')).roleId
              let flag = this.treeIds.indexOf(13)
              if(this.roleId == roleId){
                if(flag == '-1'){
                  this.$router.push({ path: "/dashboard"})
                }
                window.location.reload()
              }
              this.loading = true
            }else{
              this.$message.error(res.msg)
              this.loading = true
            }
          })
        }else{
          _api.roleAdd(params).then(res => {
            if(res.code === 1){
              this.$message.success("操作成功")
              this.$router.push({ path: "/systemManage/RolePurview"})
              let roleId = JSON.parse(localStorage.getItem('user')).roleId
              let flag = this.treeIds.indexOf(13)
              if(this.roleId == roleId){
                if(flag == '-1'){
                  this.$router.push({ path: "/dashboard"})
                }
                window.location.reload()
              }
              this.loading = true
            }else{
              this.$message.error(res.msg)
              this.loading = true
            }
          })
        }
        
      }
    },
    // 返回
    handerClose(){
      this.$router.go(-1)
    },
    // 菜单
    getSubMenu(menuItem){
      
      this.treeListIds = []
      console.log(this.treeListIds);
      menuItem.forEach(item => {
        if(item.isSelected){
          this.treeIds.push(item.id)
          if(item.menuName == '首页'){
            this.treeListIds.push(item.id)
          }
          if(item.menuName == '环比数据统计'){
            this.treeListIds.push(item.id)
          }
        }
        if(item.isSelected && item.children && item.children.length>0){
          item.children.forEach(ele => {
            if(ele.isSelected){
              console.log(ele);
              this.treeListIds.push(ele.id)
              this.treeIds.push(ele.id)
            }
          })
        }
      });
    }
  }
};
</script>
<style scoped lang="scss" ref="stylesheet/scss">
.RoleAdd {
  .formRole {
    width: 100%;
    background-color: white;
    border-radius: 20px;
    .line {
      border: 1px solid #edeffd;
    }
    .case-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      .icon_title {
        display: flex;
        .case-title_icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
        .case-title_max {
          display: inline-block;
          width: 100px;
          height: 17px;
          font-size: 18px;
          font-family: FZLanTingHei-B-GBK;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }
    }
    .formitemTree{
      margin: auto;
      width: 95%;
      display: flex;
      margin: 20px;
      justify-content: left;
      .title_Tree {
          width: 6%;
          font-size: 14px;
          font-family: FZLanTingHei-M-GBK;
          font-weight: 400;
          color: #666666;
          height: 40px;
          line-height: 40px;
        }
        .treeForm{
          width: 95%;
            border: 1px solid #edeffd;
            // min-height: 420px;
            padding-bottom: 20px;
          }
    }
    .formdata {
      margin: auto;
      width: 95%;
      .formitem {
        display: flex;
        margin: 20px;
        justify-content: left;
        div:first-child {
          width: 6%;
          font-size: 14px;
          font-family: FZLanTingHei-M-GBK;
          font-weight: 400;
          color: #666666;
          height: 40px;
          line-height: 40px;
        }
        div:last-child {
          width: 95%;
        }
      }
    }
    .subBtn{
      margin-left: 7%;
      padding: 50px 0;
    }
  }
}
</style>